import React from 'react';
import { Route } from 'react-router-dom';
import './App.css';
import HomePage from './HomePage/HomePage';
import AboutUs from './AboutUs/AboutUs';
import Team from './Team/Team';
import Demographics from './Solutions/Demographics/Demographics';
import DataInnovation from './Solutions/DataInnovation/DataInnovation';
import DataAnalytics from './Solutions/DataAnalytics/DataAnalytics';
import OmniChannel from './Solutions/OmniChannel/OmniChannel';
import PortfolioPage from './PortfolioPage/PortfolioPage';
import Products from './Solutions/Products/Products';
import PortfolioProject from './PortfolioPage/PortfolioProject/PortfolioProject';
import Moja from './PortfolioPage/Moja/Moja';
import FMD from './PortfolioPage/FMD/FMD';
import Careers from './Careers/Careers';
import Contact from './Contact/Contact';
import Presence from './Presence/Presence';
import VacancyPage from './Careers/VacancyPage/VacancyPage';
import { AnimatedSwitch } from 'react-router-transition';
import Router from 'react-router-dom/BrowserRouter';
import 'font-awesome/css/font-awesome.min.css';
import ReactGA from 'react-ga';

class App extends React.Component{
    componentDidMount() {
        ReactGA.initialize('UA-133501088-1');
        ReactGA.pageview('/');
    }
    render() {
       return (
        <div className="App">
        <Router>
            <AnimatedSwitch
                atEnter={{ opacity: 0 }}
                atLeave={{ opacity: 0 }}
                atActive={{ opacity: 1 }}
                className="switch-wrapper"
                >
                <Route  exact path="/" component={HomePage} />
                <Route  path="/aboutus/" component={AboutUs}  />
                <Route  path="/team/" component={Team}  />
                <Route  path="/demographics/" component={Demographics}  />
                <Route path="/data-innovation/" component={DataInnovation} />
                <Route path="/data-analytics/" component={DataAnalytics} />
                <Route path="/omni-channel/" component={OmniChannel} />
                <Route exact path="/case-studies/" component={PortfolioPage} />
                <Route path="/products/" component={Products} />
                <Route exact path="/infosport/" component={PortfolioProject} />
                <Route exact path="/moja/" component={Moja} />
                <Route exact path="/fmd/" component={FMD} />
                <Route excat path="/careers/" component={Careers} />
                <Route excat path="/contact/" component={Contact} />
                <Route excat path="/presence/" component={Presence} />
                <Route  path="/vacancyPage/:id" component={VacancyPage} />
            </AnimatedSwitch>
        </Router>
        </div>
       );
    }
}
export default App;
